module.exports = __webpack_public_path__ + "img/imprimir-placa-mascara.eea835eb.jpg";